import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CarFront } from 'lucide-react';

/**
 * Everything a fleet tenant configures, in one place (CUR-1069 follow-up): the
 * client database, escalations, the default delegated authority and the portal
 * claim page. The fleet module gates the whole section, so a tenant without it
 * never sees the card.
 */
export const Route = createFileRoute('/console/$orgId/configuration/fleet')({
    staticData: {
        ui: {
            icon: CarFront,
            title: 'Fleet',
            subtitle: 'Fleet clients, escalations, delegated authority and the fleet portal',
            menuDescription: 'Fleet clients, escalations, delegated authority and the fleet portal',
        },
        breadcrumb: {
            title: 'Fleet',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        modules: ['fleet'],
    },
    component: Outlet,
});
